/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect, useRef } from 'react';
import { View, StyleSheet, TouchableOpacity, FlatList } from 'react-native';
import { isWeb } from '@global/screens';
import { parseDate } from '@global/helpers';
import Colors from '@/global/colors';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';

const ActivityCalendar = ({
  firstDate,
  selected = new Date(),
  userActivity,
  userColors,
  isHideMobile,
  onHideMobile,
  onChange,
}) => {
  const flatlistRef = useRef();
  const today = new Date();
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const [lists, setLists] = useState([[], [], [], [], [], [], []]);
  const [mobileLists, setMobileLists] = useState([[], [], [], [], [], [], []]);
  const [selectedDate, setSelectedDate] = useState(new Date());

  // set selected date by default
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setSelectedDate(selected);
    }
    return () => {
      mounted = false;
    };
  }, [selected]);

  // set scroll position to selected date on mobile only
  useEffect(() => {
    let mounted = true;
    if (mounted && !isWeb && isHideMobile) {
      onScrollDate();
    }
    return () => {
      mounted = false;
    };
  }, [isHideMobile]);

  // convert date calendar
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      const dates = [[], [], [], [], [], [], []];
      const mobile_dates = [];
      let index = 0;
      const start_date_month = new Date(
        firstDate.getFullYear(),
        firstDate.getMonth(),
        1, // Changed from firstDate.getDate() to 1 to start at the beginning of the month
      );
      const end_date_month = new Date(
        firstDate.getFullYear(),
        firstDate.getMonth() + 1,
        0,
      );
      for (let i = 0; i < start_date_month.getDay(); i++) {
        dates[0].push('');
      }
      for (let i = 1; i <= end_date_month.getDate(); i++) {
        const date = new Date(firstDate.getFullYear(), firstDate.getMonth(), i);
        dates[index].push(date);
        mobile_dates.push(date);
        if (dates[index].length >= 7) {
          index += 1;
        }
      }
      setLists(dates);
      setMobileLists(mobile_dates);
      if (!isWeb && isHideMobile) {
        onScrollDate();
      }
    }
    return () => {
      mounted = false;
    };
  }, [firstDate]);

  // check if its the date
  const checkDate = (value, type = 'getDate', no_value = false) =>
    value ? value[type]() : no_value ? '' : '-';
  // check active date
  const isActive = (value) => {
    const date = checkDate(value);
    const month = checkDate(value, 'getMonth');
    const year = checkDate(value, 'getFullYear');
    return (
      selectedDate.getDate() == date &&
      selectedDate.getMonth() == month &&
      selectedDate.getFullYear() == year
    );
  };
  // check today date
  const isToday = (value) => {
    const date = checkDate(value);
    const month = checkDate(value, 'getMonth');
    const year = checkDate(value, 'getFullYear');
    return (
      today.getDate() == date &&
      today.getMonth() == month &&
      today.getFullYear() == year
    );
  };
  // handling the date if there are have user activity
  const checkDot = (value) => {
    const act = userActivity;
    const currentMonth = parseDate(firstDate, 'MMMM');
    const match = act[currentMonth];
    if (match && value && match[parseDate(value, 'yyyy-LL-dd')]) {
      const result = match[parseDate(value, 'yyyy-LL-dd')];
      if (result && result.length) {
        const merge = [
          ...new Set(result.flatMap(({ user }) => (user ? user.id : '-'))),
        ].sort();
        const getColor = merge.map((a) => userColors[a]);
        return getColor.slice(0, 4);
      }
    }
    return [];
  };

  // handling selected date
  const onSelectDate = (date) => {
    if (!isHideMobile) {
      onHideMobile(true);
    }
    setSelectedDate(date);
    try {
      onChange(date);
    } catch (error) {}
  };

  // handling hide calendar on mobile only
  const onHide = () => {
    const val = !isHideMobile;
    onHideMobile(val);
  };

  // scroll into selected date activity
  const onScrollDate = () => {
    setTimeout(() => {
      let index = 0;
      if (
        mobileLists &&
        mobileLists.length &&
        selected.getMonth() == firstDate.getMonth()
      ) {
        const idx = mobileLists.findIndex(
          (a) => new Date(a).getDate() == selected.getDate(),
        );
        if (idx > -1) {
          index = idx;
        }
      }
      flatlistRef.current.scrollToIndex({ animated: true, index: index });
    }, 250);
  };

  // activity user active container
  const DateDotContainer = ({ children }) => (
    <View style={[styles.centered, { width: '100%', minHeight: 4 }]}>
      {children}
    </View>
  );

  // activity user item
  const DateDot = ({ color }) => (
    <View
      style={{
        width: 5,
        height: 5,
        borderRadius: 5,
        marginHorizontal: 2,
        backgroundColor: color ? color : 'transparent',
      }}></View>
  );

  // date item container
  const DateItem = ({ item, onSelectDate }) => {
    return (
      <View style={styles.dateItem}>
        <TouchableOpacity
          activeOpacity={0.6}
          onPress={() =>
            item
              ? onSelectDate(
                  new Date(
                    item.getFullYear(),
                    item.getMonth(),
                    checkDate(item),
                  ),
                )
              : false
          }
          style={[
            styles.dateSubItem,
            isToday(item)
              ? {
                  backgroundColor: Colors.blue7,
                }
              : isActive(item)
              ? {
                  backgroundColor: Colors.grey0,
                }
              : {},
          ]}>
          <View style={[styles.centered, { width: '100%', height: 22 }]}>
            <SociollaText
              style={{
                fontSize: 16,
                ...(isToday(item)
                  ? {
                      color: Colors.blue0,
                    }
                  : isActive(item)
                  ? {
                      color: Colors.black,
                    }
                  : {}),
              }}>
              {checkDate(item, 'getDate', true)}
            </SociollaText>
          </View>
          {checkDot(item) && checkDot(item).length ? (
            <DateDotContainer>
              {checkDot(item).map((item_2, childIdx) => (
                <DateDot color={item_2} key={childIdx} />
              ))}
            </DateDotContainer>
          ) : (
            false
          )}
        </TouchableOpacity>
      </View>
    );
  };

  return (
    <View style={{ width: '100%' }}>
      {/* Start Calendar Month & Year Container */}
      <View
        style={{
          width: '100%',
          paddingVertical: isWeb ? 20 : 15,
          paddingHorizontal: isWeb ? 20 : 15,
        }}>
        <View style={{ position: 'relative', width: '100%' }}>
          <TouchableOpacity
            activeOpacity={1}
            onPress={() => (!isWeb ? onHide() : null)}
            style={{
              width: 100,
              backgroundColor: Colors.white,
              zIndex: 1,
              elevation: 1,
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingRight: 7,
            }}>
            <SociollaText type="bold" style={{ fontSize: 16 }}>
              {parseDate(firstDate, 'MMM')} {parseDate(firstDate, 'yyyy')}
            </SociollaText>
            {!isWeb ? (
              <Image
                style={{
                  width: 10,
                  height: 6,
                  transform: [{ rotate: isHideMobile ? '0deg' : '180deg' }],
                }}
                width={10}
                height={6}
                svg={true}
                source={require('@/assets/img/icons/arrow-down-grey.svg')}
              />
            ) : (
              false
            )}
          </TouchableOpacity>
          <View
            style={{
              width: '80%',
              height: 2,
              position: 'absolute',
              top: 7,
              left: 0,
              backgroundColor: Colors.grey0,
            }}></View>
        </View>
      </View>
      {/* End Calendar Month & Year Container */}
      {/* Start Full Calendar Container */}
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          flexWrap: 'wrap',
          paddingVertical: 10,
        }}>
        {!isWeb && isHideMobile ? (
          // Inline Calendar Container
          <FlatList
            horizontal
            data={mobileLists}
            keyExtractor={(item, index) => `mobile-calender-${index}`}
            renderItem={({ item, index }) => (
              <TouchableOpacity
                onPress={() =>
                  onSelectDate(
                    new Date(
                      item.getFullYear(),
                      item.getMonth(),
                      checkDate(item),
                    ),
                  )
                }
                activeOpacity={0.6}
                style={[
                  {
                    width: 55,
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingHorizontal: 10,
                    paddingVertical: 5,
                    borderRadius: 5,
                  },
                  index == 0
                    ? {
                        marginLeft: 10,
                      }
                    : {},
                  index == mobileLists.length - 1
                    ? {
                        marginRight: 10,
                      }
                    : {},
                  isToday(item)
                    ? {
                        backgroundColor: Colors.blue7,
                      }
                    : isActive(item)
                    ? {
                        backgroundColor: Colors.grey0,
                      }
                    : {},
                ]}>
                <SociollaText
                  style={{
                    fontSize: 12,
                    color: isToday(item) ? Colors.blue0 : Colors.black5,
                    marginBottom: 2,
                  }}>
                  {parseDate(item, 'eee').toUpperCase()}
                </SociollaText>
                <SociollaText
                  type="medium"
                  style={{
                    fontSize: 18,
                    color: isToday(item) ? Colors.blue0 : Colors.black5,
                    marginBottom: 2,
                  }}>
                  {item.getDate()}
                </SociollaText>
                {checkDot(item) && checkDot(item).length ? (
                  <DateDotContainer>
                    {checkDot(item).map((item_2, childIdx) => (
                      <DateDot color={item_2} key={childIdx} />
                    ))}
                  </DateDotContainer>
                ) : (
                  false
                )}
              </TouchableOpacity>
            )}
            ref={flatlistRef}
            getItemLayout={(data, index) => ({
              length: 50,
              offset: 50 * index,
              index,
            })}
            showsHorizontalScrollIndicator={false}
          />
        ) : (
          // Default Calendar Container
          <>
            {days.map((item, idx) => (
              <View
                key={idx}
                style={[
                  styles.centered,
                  { width: '14.28%', minWidth: '14.28%', marginVertical: 10 },
                ]}>
                <SociollaText style={{ color: Colors.black5 }}>
                  {(isWeb ? item : item[0]).toUpperCase()}
                </SociollaText>
              </View>
            ))}
            {lists.map((item, idx) => {
              return item.map((itemChild, childIdx) => (
                <DateItem
                  item={itemChild}
                  key={`${idx}-${childIdx}`}
                  onSelectDate={(val) => onSelectDate(val)}
                />
              ));
            })}
          </>
        )}
      </View>
      {/* End Full Calendar Container */}
    </View>
  );
};

const styles = StyleSheet.create({
  centered: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dateItem: {
    width: '14.28%',
    minWidth: '14.28%',
    flexDirection: 'row',
    justifyContent: 'center',
    marginVertical: 10,
  },
  dateSubItem: {
    minWidth: 40,
    paddingHorizontal: 8,
    paddingVertical: 12,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
  },
});

export default ActivityCalendar;
